import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { ProductCategoriesApiAdapter } from '../adapters/ProductCategoriesApiAdapter';

export const PRODUCT_CATEGORIES_QUERY_KEY = 'product-categories';

export const useProductCategories = (name?: string) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ProductCategoriesApiAdapter(httpClient);

  return useQuery({
    queryKey: [PRODUCT_CATEGORIES_QUERY_KEY, name ?? ''],
    queryFn: () => adapter.getAll(name ? { name } : undefined),
    staleTime: 2 * 60 * 1000,
  });
};
